module.exports = __webpack_public_path__ + "img/cleaner.b0e92780.png";